import React from "react";
import format from "date-fns/format";

const header = {
    padding: "20px 30px 0 30px",
    position: "relative",
    margin: "0 0 20px 0",
};

const quote_nr2 = {
    fontSize: "13px",
    lineHeight: "16px",
    textAlign: "right",
};

const QuotePDFHeader = ({ quote, pagenr }) => {
    return (
        <div style={header}>
            <table style={{ width: "100%" }}>
                <tr>
                    <td style={{ width: "60%" }} align="left" valign="middle">
                        <img src="https://leads.igotravel.co.za/assets/logo_pdf2.png" alt="IGO Travel" />
                    </td>

                    <td style={quote_nr2}>
                        <p>
                            QUOTATION
                            <br />
                            QUOTE NO: {quote.createDate ? format(quote.createDate.toDate(), "yyyyMMdd") + "-" + quote.quote_nr + "-" + quote.quote_rev : ""}
                            <br />
                            Page {pagenr}
                        </p>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default QuotePDFHeader;
